import React from "react";
import { FormFieldLabel, FormHelperText } from "./FormField";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string;
  type: string;
  placeholder: string;
  label?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  fullWidth?: boolean;
  startAdornment?: React.ReactNode;
  endAdornment?: React.ReactNode;
  labelClassName?: string;
  error?: boolean;
  helperText?: string;
  className?: string;
  pattern?: string;
  inputRef?: React.Ref<HTMLInputElement>; // input ref, like for auto focus on mount
  required?: boolean;
  optional?: boolean;
}

const Input: React.FC<InputProps> = ({
  name,
  type,
  placeholder,
  label = "",
  value,
  onChange,
  fullWidth = false,
  startAdornment,
  endAdornment,
  labelClassName,
  error,
  helperText,
  className,
  pattern,
  inputRef,
  required = false,
  optional = false,
  ...props
}) => {
  return (
    <div
      className={`flex flex-col ${className} ${fullWidth ? "w-full" : "w-fit"}`}
    >
      <FormFieldLabel
        label={label}
        required={required}
        optional={optional}
        className={labelClassName}
      />

      <div
        className={`bg-white flex items-center border border-gray-300 rounded-xl overflow-hidden focus-within:border-[var(--app-primary)] ${
          fullWidth ? "w-full" : "w-fit"
        }`}
      >
        {startAdornment && (
          <div className="flex items-center gap-2 pl-3 text-gray-400">
            {startAdornment}
          </div>
        )}
        <input
          ref={inputRef}
          type={type}
          placeholder={placeholder}
          className={`px-3 py-[10px] text-sm focus:outline-none focus:ring-2 focus:ring-transparent placeholder:text-gray-400 placeholder:text-sm ${
            fullWidth ? "w-full" : "w-fit"
          } ${
            props?.disabled
              ? "text-gray-400 bg-gray-50 cursor-not-allowed"
              : "text-black bg-white"
          }`}
          name={name}
          value={value}
          onChange={onChange}
          pattern={pattern}
          {...props}
        />
        {endAdornment && (
          <div className="flex items-center gap-2 pr-1 text-gray-400">
            {endAdornment}
          </div>
        )}
      </div>

      <FormHelperText helperText={helperText} error={error} />
    </div>
  );
};

export default Input;
